import { Field } from 'formik'
import get from 'lodash-es/get'
import React, { useEffect, useRef, useState } from 'react'

import { WeightInput } from '@components/common/WeightInput'
import { ColorInput, Input, useMediaQueryContext } from '@fourthwall/components'

import * as S from './styled'
import type { ProductVariantProps } from './types'

export const ProductVariant = ({
  variantTypeIndex,
  index,
  type,
  errors,
  variesByWeight,
  showWeightsInfo,
  shouldAutofocusName = false,
}: ProductVariantProps) => {
  const media = useMediaQueryContext()
  const [isColorInputFocused, setIsColorInputFocused] = useState(false)
  const [isColorSwatchInputFocused, setIsColorSwatchInputFocused] = useState(false)
  const nameWrapperRef = useRef<HTMLDivElement>(null)
  const fieldSize = media.tablet ? 'large' : 'medium'

  useEffect(() => {
    if (shouldAutofocusName) {
      nameWrapperRef.current?.getElementsByTagName('input')[0]?.focus()
    }
  }, [])

  const hasError = (fieldName: any) => {
    return !!get(errors, `types[${variantTypeIndex}].options[${index}].${fieldName}`)
  }

  const renderColorControl = () => (
    <S.ColorWrapper>
      <S.NameWrapper ref={nameWrapperRef} active={isColorInputFocused || hasError('name')}>
        <Field
          name={`types[${variantTypeIndex}].options[${index}].name`}
          component={Input}
          displayError={false}
          label="Color name"
          size={fieldSize}
          onFocus={() => setIsColorInputFocused(true)}
          onBlur={() => setIsColorInputFocused(false)}
        />
      </S.NameWrapper>
      <S.ColorSwatchWrapper active={isColorSwatchInputFocused}>
        <Field
          name={`types[${variantTypeIndex}].options[${index}].colorSwatch`}
          component={ColorInput}
          size={fieldSize}
          onOpen={() => setIsColorSwatchInputFocused(true)}
          onClose={() => setIsColorSwatchInputFocused(false)}
        />
      </S.ColorSwatchWrapper>
    </S.ColorWrapper>
  )

  const renderSizeControl = () => (
    <S.NameWrapper ref={nameWrapperRef}>
      <Field
        name={`types[${variantTypeIndex}].options[${index}].name`}
        component={Input}
        label="Size name"
        displayError={false}
        size={fieldSize}
      />
    </S.NameWrapper>
  )

  const renderCustomControl = () => (
    <S.NameWrapper ref={nameWrapperRef}>
      <Field
        name={`types[${variantTypeIndex}].options[${index}].name`}
        component={Input}
        label="Variant name"
        displayError={false}
        size={fieldSize}
      />
    </S.NameWrapper>
  )

  const renderWeightControl = () => {
    if (!variesByWeight || showWeightsInfo) return null

    return (
      <S.WeightContainer>
        <WeightInput
          weightName={`types[${variantTypeIndex}].options[${index}].weight.value`}
          unitName={`types[${variantTypeIndex}].options[${index}].weight.unit`}
          weightWidth={media.tablet ? 88 : '100%'}
          unitWidth={media.tablet ? 80 : '100%'}
          size={fieldSize}
        />
      </S.WeightContainer>
    )
  }

  return (
    <S.Container>
      {type === 'COLOR' && renderColorControl()}
      {type === 'SIZE' && renderSizeControl()}
      {type === 'CUSTOM' && renderCustomControl()}
      {renderWeightControl()}
      {showWeightsInfo && <S.InfoText>Enter weight on the product page</S.InfoText>}
    </S.Container>
  )
}
